import request from '@/utils/request'

/**
 * 获取祠堂列表
 * GET /ancestral/halls
 * @param {Object} [params] - { page, page_size, keyword } 等
 */
export function getHallList(params) {
  return request.get('/ancestral/halls', params || {})
}
